export enum SearchConstants {
    MaxSearchKeywords = 3,
    MaxNarrowKeywords = 1,
    SearchKeywordsError = 'Keyword input is limited to 3 keywords',
    SearchNarrowError = 'Keyword input is limited to 1 keyword',
}
